<template lang="html">
  <section>
  	DISPLAY
  </section>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Display.vue?48d56a00